<template>
  <QuickActionButton
    icon="icon-repeat"
    :title="isNextLink ? 'Replace NextLink' : 'Replace Repeater'"
    :subtitle="`Quickly replace ${repeaterIdStr} with another Network Device`"
    @click="replaceRepeaterModal?.$el?.present()"
  ></QuickActionButton>
  <IonModal ref="replaceRepeaterModal">
    <IonHeader class="ion-no-border px-[10px] bg-white">
      <IonToolbar color="white" class="border-b-2 border-gray-300">
        <IonTitle color="medium"><i class="icon-repeat mr-2"></i>Replace {{ repeaterIdStr }}</IonTitle>
        <IonButtons slot="end">
          <IconButton icon="icon-x" @click="replaceRepeaterModal?.$el?.dismiss()"></IconButton>
        </IonButtons>
      </IonToolbar>
    </IonHeader>
    <IonContent>
      <ReplaceDeviceForm :device-to-replace="repeaterId" @on-replace-result="onReplaceResult"></ReplaceDeviceForm>
    </IonContent>
  </IonModal>
</template>

<script setup lang="ts">
import IconButton from '@/components/forms/IconButton.vue';
import QuickActionButton from '@/components/forms/QuickActionButton.vue';
import { useToast } from '@/composables/use-toast';
import { ReplaceDeviceResult } from '@/http-services/device.service';
import { useSelectedProperty } from '@/stores/selected-property.store';
import ReplaceDeviceForm from '@/views/tools/replace-device/ReplaceDeviceForm.vue';
import {
  createAnimation,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonModal,
  IonTitle,
  IonToolbar,
  useIonRouter,
} from '@ionic/vue';
import { ConversionUtils, DeviceTypeHelper, DeviceTypeIds } from '@ncss/models';
import { computed, useTemplateRef } from 'vue';

const props = defineProps<{ repeaterId: number }>();
const isNextLink = computed(() => DeviceTypeHelper.GetIdBySerialNumber(props.repeaterId) === DeviceTypeIds.NL4);
const { successToast, errorToast } = useToast();
const repeaterIdStr = computed(() => props.repeaterId.toString(16).toUpperCase());
const replaceRepeaterModal = useTemplateRef('replaceRepeaterModal');
const selectedProperty = useSelectedProperty();
const router = useIonRouter();

function present() {
  return replaceRepeaterModal.value?.$el?.present();
}

async function onReplaceResult(res: ReplaceDeviceResult) {
  if (res.success) {
    const repeaterId = res.device.deviceId;
    const propertyId = selectedProperty.property?._id;
    const snStr = ConversionUtils.ConvertSerialNumberToString(repeaterId);
    successToast(`${snStr} programmed!`);
    await replaceRepeaterModal.value?.$el?.dismiss();
    await selectedProperty.refresh();
    setTimeout(() => {
      if (propertyId) {
        router.replace(`/repeater/${propertyId}/${repeaterId}`, () => createAnimation());
      }
    }, 100);
  } else {
    const msg = res.errors[0].msg;
    errorToast(msg || 'Failed to replace repeater');
  }
}

defineExpose({ present });
</script>

<style scoped></style>
